import BannerImg from '../assets/banner.webp';
import BannerScreen from '../assets/banner-screen.webp';
import MobilePlanet from '../assets/banner-mobile-planet.webp';
import MobileScreen from '../assets/banner-mobile-screen.webp';
import MobileZook from '../assets/banner-mobile-zook.webp';
import RotatingCoin from './RotatingCoin';
import SwapTC from '../assets/swap-tc.webp'
import SwapTCShine from '../assets/swap-tc-shine.webp'

const Banner = () => (
  <>
    <div className="banner justify-center relative px-20 hidden xl:flex">
      <img src={BannerImg} alt="ZKcandy" />
      <a target="_blank" rel="noopener noreferrer" href="https://zkcandy.notion.site/KRO-CANDY-TOKEN-SWAP-TERMS-OF-SERVICE-1f8514dde58280f0a383d441ec5fa968" className="absolute w-[12%] right-[37%] top-[4%] hover:scale-[1.1] z-[2] transition-all duration-200">
        <img src={SwapTC} alt="Swap T&C" />
        <img src={SwapTCShine} alt="Swap T&C" className="absolute top-0 left-0 animate-opacity-blink" />
      </a>
      <img className="absolute left-0 top-0 animate-banner-screen" src={BannerScreen} alt="ZKcandy" />
      <div className="absolute bottom-[16%]">
        <RotatingCoin />
      </div>
    </div>

    <div className="flex justify-center xl:hidden relative">
      <img src={MobilePlanet} alt="ZKcandy" />
      <img src={MobileScreen} alt="ZKcandy" className="absolute animate-banner-screen" />
      <img src={MobileZook} alt="ZKcandy" className="absolute" />
      <div className="absolute bottom-[16%]">
        <RotatingCoin />
      </div>
      <a target="_blank" href="https://zkcandy.notion.site/KRO-CANDY-TOKEN-SWAP-TERMS-OF-SERVICE-1f8514dde58280f0a383d441ec5fa968" rel="noopener noreferrer" className="absolute w-[25%] right-[38%] top-[4%] hover:scale-[1.1] z-[3] transition-all duration-200">
        <img src={SwapTC} alt="Swap T&C" />
        <img src={SwapTCShine} alt="Swap T&C" className="absolute top-0 left-0 animate-opacity-blink" />
      </a>
    </div>

  </>
);

export default Banner;
